<template>
  <div class="form-input-container">
    <div class="form-title"><label>
      <template v-if="label != null">{{translate(label)}} </template> 
      <template v-else><span class="show-web">‎ </span></template>
      <span class="required" v-if="required">*</span>
    </label>
    </div>
    <div style="display: flex; align-items: center;">
      <span style="margin-right: 10px;" v-if="left_label != null">{{translate(left_label)}}</span>
      <input class="form-input" v-model="model" :disabled="disabled" :type="type">
      <span style="margin-left: 10px;" v-if="right_label != null">{{translate(right_label)}}</span>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'stats-card',
    props: {
      value: {}, label:{}, right_label: {}, left_label: {},
      required: {
        type: Boolean,
        default: true
      },
      type: {
        type: String,
        default: "text"
      },
      disabled: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        localValue: this.value
      }
    },
    created() {
      this.setFieldValue()
    },
    methods: {
      setFieldValue() {
        this.localValue = this.model
      },
    },
    watch: {
      model() {
        this.setFieldValue()
      },
      localValue(val) {
        this.$emit('input', val)
      },
      value(val) {
        this.localValue = val
      }
    },
    computed: {
      model: {
        get() {
          return this.localValue
        },
        set(value) {
          if (value.constructor.name.toLowerCase() !== 'inputevent') {
            this.$nextTick(() => {
              this.localValue = value
            })
          }
        }
      },
    }
  }
</script>

<style scoped>
  .form-input-container {
    margin-bottom: 20px;
    color: #353690;
  }

  .form-title {
    margin-bottom: 8px;
  }

  .form-input {
    width: 100%;
    height: 38px;
    font-size: 14px;
    padding: 4px 12px;
    border: 2px solid #EEE;
    border-radius: 6px;
    font-family: "Open Sans", "Hanuman", sans-serif;
    color: #353690;
  }

  .form-input:focus {
    border: 2px solid #353690;
  }
</style>


// WEBPACK FOOTER //
// src/components/Form/Input.vue